import { render } from "./ApplicationMGAgComponent.vue?vue&type=template&id=b98f06e6&scoped=true&ts=true"
import script from "./ApplicationMGAgComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationMGAgComponent.vue?vue&type=script&lang=ts"

import "./ApplicationMGAgComponent.vue?vue&type=style&index=0&id=b98f06e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98f06e6"]])

export default __exports__